export enum ExceptionType {
  AdminAuthRequired = 'adminAuth',
}
